import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonUtilsModule } from "../common-utils/common-utils.module";

import { CommonSearchbarActionsDirective } from "./actions.directive";
import { CommonSearchbarComponent } from "./common-searchbar.component";
import { searchbarStatePropProvider } from "./state-props";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CommonUtilsModule,
    ],
    exports: [
        CommonSearchbarComponent,
        CommonSearchbarActionsDirective,
    ],
    declarations: [
        CommonSearchbarComponent,
        CommonSearchbarActionsDirective,
    ],
    providers: [
        searchbarStatePropProvider,
    ],
})
export class CommonSearchbarModule {
}
